module.exports = __webpack_public_path__ + "static/media/sudo_x.74d8883c.png";